import { Component, Input } from '@angular/core';

/**
 * Handles raci counter card component
 */
@Component({
  selector: 'raci-counter-card',
  templateUrl: './raci-counter-card.component.html',
  styleUrls: ['./raci-counter-card.component.css', '../../../../css/projectValuation.css']
})
export class RaciCounterCardComponent {
  /**
   * Input to receive the link counter data
   */
  @Input() linkCounter: any;
}
